export default {
  ConfirmTradingPair: 'confirm-trading-pair',
  IDOInfo: 'project-ido-info',
  AdditionalInformation: 'additional-information',
  TokenBalance: 'token-balance',
  Currency: 'currency',
};
